import Honeybadger from 'honeybadger-js';
import { get } from 'js-cookie';

const onDownloadRsvpResponses = async (): Promise<void> => {
  const path = `${process.env.REACT_APP_GDS_API_ENDPOINT}/v1/rsvp/export`;
  const headers = {
    'Content-Type': 'text/csv',
    Accept: 'text/csv',
    'MEMBERSHIP-SESSION-TOKEN': get('xo-session-token') || '',
    'X-API-KEY': process.env.REACT_APP_GDS_API_KEY || '',
  };

  try {
    const response = await fetch(path, { headers });
    const data = await response.blob();
    const fileName = 'My Rsvp List.csv';
    // IE10+ has Blob, but not a[download]
    if (navigator.msSaveBlob) {
      navigator.msSaveBlob(data, fileName);
    } else {
      const a = document.createElement('a');
      const url = window.URL.createObjectURL(data);
      a.href = url;
      a.download = fileName;
      a.click();
      window.URL.revokeObjectURL(url);
    }
  } catch (error) {
    Honeybadger.notify(error, {
      message: 'Error downloading csv data',
      context: {
        error,
      },
    });
  }
};

export default onDownloadRsvpResponses;
